
import {defineComponent, PropType} from "vue";
import {BoxShadowRestDto} from "@/api/pharma-cms-content-page/models";
import {BoxShadowRestDtoModel} from "@/models/api/pharma-cms-content-page/BoxShadowRestDtoModel";
import {BoxShadowValueRestDtoModel} from "@/models/api/pharma-cms-content-page/BoxShadowValueRestDtoModel";
import {ComponentMixin} from "@/components/base/ComponentMixin";
import GenericComponentWrapper from "@/components/base/GenericComponentWrapper.vue";
import MetadataGroupCard from "@/components/layouts/content-pages/wysiwyg/misc/MetadataGroupCard.vue";
import BoxShadowLayerDetail from "@/components/layouts/content-pages/wysiwyg/misc/BoxShadowLayerDetail.vue";
import BaseDeleteButton from "@/components/UI/Bootstrap/BaseDeleteButton.vue";

export default defineComponent({
  name: "BoxShadowDetail",
  mixins: [ComponentMixin],
  components: {GenericComponentWrapper, MetadataGroupCard, BoxShadowLayerDetail, BaseDeleteButton},
  emits: ['update:modelValue'],
  props: {
    // Null means the group is switched off.
    modelValue: {
      type: Object as PropType<BoxShadowRestDto | null>,
      required: false,
      default: null,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.persistedDto = this.modelValue ? BoxShadowRestDtoModel.cloneFrom(this.modelValue) : null;

    this.componentUI.setReady();
  },
  data() {
    return {
      enabled: false as boolean,
      localDto: BoxShadowRestDtoModel.createWithDefaults() as BoxShadowRestDto,
      // Values entered before the group was switched off, so they can be restored.
      lastActiveDto: null as BoxShadowRestDto | null,
      // Reset baseline: the state as it is stored in the database.
      persistedDto: null as BoxShadowRestDto | null,
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newValue: BoxShadowRestDto | null) {
        this.enabled = !!newValue;
        if (newValue) {
          this.localDto = BoxShadowRestDtoModel.cloneFrom(newValue);
        }
      },
    },
  },
  computed: {
    hasMultipleLayers(): boolean {
      return this.localDto.layers.length > 1;
    },
  },
  methods: {
    onEnabledChanged(newValue: boolean): void {
      if (newValue === this.enabled) {
        return;
      }
      this.enabled = newValue;

      if (newValue) {
        this.localDto = this.lastActiveDto
          ? BoxShadowRestDtoModel.cloneFrom(this.lastActiveDto)
          : BoxShadowRestDtoModel.createWithDefaults();

        this.$emit('update:modelValue', this.localDto);
      } else {
        this.lastActiveDto = BoxShadowRestDtoModel.cloneFrom(this.localDto);

        this.$emit('update:modelValue', null);
      }
    },
    resetToPersisted(): void {
      this.localDto = this.persistedDto
        ? BoxShadowRestDtoModel.cloneFrom(this.persistedDto)
        : BoxShadowRestDtoModel.createWithDefaults();

      this.$emit('update:modelValue', this.localDto);
    },
    addLayer(): void {
      this.localDto.layers.push(BoxShadowValueRestDtoModel.createWithDefaults());
      this.emitModelChanged();
    },
    removeLayer(index: number): void {
      this.localDto.layers.splice(index, 1);
      this.emitModelChanged();
    },
    emitModelChanged(): void {
      this.$emit('update:modelValue', this.localDto);
    },
  },
});
